import { Component, OnInit } from "@angular/core";

import { GrowlService } from "@lantern/app/core/utils/growl-service";

import { GlobalAuthService } from "@local/app/core/global-auth";

@Component({
  selector: "ta-lcl-logout",
  templateUrl: "logout.template.html"
})
export class LogoutComponent implements OnInit {
  constructor(
    private globalAuthService: GlobalAuthService,
    private growlService: GrowlService
  ) {}

  ngOnInit(): void {
    this.globalAuthService
      .logout()
      .subscribe(() => this.growlService.success("Logged out!"));
  }
}
